import { DialogTitle as MuiDialogTitle } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import cx from 'classnames';
import React, { ReactNode } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';
import { IconButton } from '@shared/components/icon-button';
import { ButtonSize, NewButtonColour } from '@shared/types/common/button';

import { styles } from './OverlayHeader.styles';
import { useOverlay } from '../../Overlay.context';

export interface OverlayHeaderProps extends WithStyles<typeof styles> {
  closeColour?: NewButtonColour;
  heading?: ReactNode;
  headingActions?: ReactNode;
}
/**
 * @deprecated Use OverlayHeaderProps instead
 */
export type ModalHeaderProps = OverlayHeaderProps;

const OverlayHeaderComponent: React.FC<OverlayHeaderProps> = ({ classes, closeColour, heading, headingActions }) => {
  const overlayContext = useOverlay();

  return (
    <MuiDialogTitle classes={{ root: cx(classes.root, { [classes.rootWithBorder]: !!heading }) }} disableTypography>
      <div className={classes.title}>
        <h1 className={classes.heading}>{heading}</h1>
        <div className={classes.headingActions}>
          {headingActions}
          <IconButton
            classes={{ root: classes.closeButton }}
            colour={closeColour ?? NewButtonColour.Ghost}
            size={ButtonSize.iconSmall}
            icon={<CloseIcon classes={{ root: classes.closeButtonIcon }} />}
            onClick={overlayContext.onCheckAndClose}
          />
        </div>
      </div>
    </MuiDialogTitle>
  );
};

export const OverlayHeader = withStyles(styles)(OverlayHeaderComponent);
/**
 * @deprecated Use OverlayHeader instead
 */
export const ModalHeader = OverlayHeader;
